<template>
  <div class="ce-resultStateIndicators">
    <div
      v-if="showNew"
      class="ce-resultStateIndicators--new" />
    <div
      v-if="showUpdated"
      class="ce-resultStateIndicators--updated" />
  </div>
</template>

<script>
export default {
  props: {
    showNew: {
      type: Boolean,
      required: false,
      default: false,
    },
    showUpdated: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-resultStateIndicators {
  display: flex;
  align-items: center;

  > div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .ce-resultStateIndicators--new {
    background: @color-secondary;
  }

  .ce-resultStateIndicators--updated {
    background: @color-light;
  }

  > div:nth-child(2) {
    position: relative;
    left: -4px;
    width: 14px;
    height: 14px;
    border: 2px solid @color-mono-100;
  }
}
</style>
